import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from '@mui/material';
import ProgramForm from './ProgramForm';  // Import the form component
import axiosInstance from '../utils/axios';

const ProgramDialog = ({ open, onClose, programData, onSubmit, simpleMode=false }) => {
    const [program, setProgram] = useState({
        name: '',
        description: '',
        status: 'ACTIVE',
    });

    useEffect(() => {
        if (programData) {
            setProgram(programData);  // Populate form with existing data if available
        }
    }, [programData]);

    const handleFormChange = (updatedProgram) => {
        setProgram(updatedProgram);
    };

    const handleSave = async () => {
        try {
            let returnEntity = null; 

            if (program.id) {
                // Update existing program
                returnEntity = await axiosInstance.put(`/programs/${program.id}/`, program);
            } else {
                // Create new program
                returnEntity = await axiosInstance.post('/programs/', program);
            }
            onSubmit(returnEntity.data);  // Callback to parent after successful save
        } catch (error) {
            console.error('Error saving program:', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{program.id ? 'Edit Program' : 'Create Program'}</DialogTitle>
            <DialogContent>
                <div style={{padding:"10px"}}>
                    <ProgramForm program={program} onChange={handleFormChange} simpleMode={simpleMode}/>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    {program.id ? 'Update' : 'Create'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProgramDialog;
